import initMetaballs from 'metaballs-js';
import {detectWebGLContext} from "../includes/detect-webgl";

const webglDetected = detectWebGLContext();
const windowBreakpoint = window.matchMedia('(min-width: 1030px)').matches;

const backgroundEnabled = false;

if(backgroundEnabled) {
    initMetaballs('#background-canvas', {
        numMetaballs: 25,
        minRadius: 15,
        maxRadius: 20,
        speed: 1,
        color: '#ffffff',
        backgroundColor: '#64c18f',
        interactive: 'window'
    });

    document.getElementById('background-canvas').classList.add('loaded');
}

